import { type ComponentPropsWithoutRef, forwardRef, type LegacyRef } from 'react';
interface TriggerContentProps extends ComponentPropsWithoutRef<'img'> {}
export const TriggerContent = forwardRef<HTMLImageElement, TriggerContentProps>((props: ComponentPropsWithoutRef<'img'>, ref) => {
  return <div className="w-[40px] tablet-sm:hidden">
        <img src="/assets/icon_menu.svg" className="cursor-pointer p-xs hover:rounded-[8px] hover:bg-opacity-black-1 tablet-sm:hidden" {...props} ref={ref as LegacyRef<HTMLImageElement>} alt="menuicon" />
      </div>;
});
TriggerContent.displayName = 'TriggerContent';